import { render, staticRenderFns } from "./TransportForm.vue?vue&type=template&id=d210dc6a&scoped=true"
import script from "./TransportForm.vue?vue&type=script&lang=js"
export * from "./TransportForm.vue?vue&type=script&lang=js"
import style0 from "./TransportForm.vue?vue&type=style&index=0&id=d210dc6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d210dc6a",
  null
  
)

export default component.exports